import { rgba } from 'polished'
import { path } from 'ramda'

export const getThemeVal = (string, defaultValue) => ({ theme }) => path(string.split('.'), theme) || defaultValue
export const getThemeColor = (color, defaultColor, rgbaVal = 1) => ({ theme }) => rgba(`${theme.colors[color]}`, rgbaVal) || defaultColor
